import styled from '@emotion/styled';
import { Theme, StyledProps } from './Tabs.types';
import css from '@styled-system/css';

const Tabs = styled.div<StyledProps, Theme>`
  ${css({
    borderBottom: '1px solid',
    borderColor: 'neutral',
  })}
`;

export default Tabs;
